import classes from "./Purchase.module.scss";
import { useContext, useEffect, useMemo, useState } from "react";
import PaymentArea from "../../components/Purchase/PaymentArea";
import ChoosePlan from "../../components/Purchase/ChoosePlan";
import { useDispatch, useSelector } from "react-redux";
import PurchaseSuccess from "../../components/Purchase/PurchaseSuccess/PurchaseSuccess";
import useFetch from "../../hooks/useFetch";
import ChooseAdd from "../../components/Purchase/ChooseAdd";
import SystemContext from "../../context/SystemContext";
import * as kApi from "../../constants/api";
import RenewPlan from "../../components/Purchase/RenewPlan/RenewPlan";
import { PROD } from "../../constants/defaults";
import PaymentProcessing from "../../components/Purchase/PaymentArea/Flow/Payment/PaymentProcessing/PaymentProcessing"
import useInstantPurchase from "./useInstantPurchase";

import { useLocation, useSearchParams } from 'react-router-dom';

const Purchase = () => {
  const { session } = useSelector((state) => state.session);
  const { infoUsers, updateTagUser, PurchaseInfo, changePropertyUrl } = useContext(SystemContext);
  const dispatch = useDispatch();
  const payload = useSelector((state) => state.purchase);
  const [groupedData, setGroupedData] = useState(null);
  const [PlanChosenId, setPlanChosenId] = useState();
  const isProd = kApi.GET_PROD_OR_DEV === PROD;
  const [Products, isLoadingProducts, hasErrorProducts, fetchProducts] = useFetch({ autoInit: false });
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const instantPay = searchParams.get("instant");
  const planSearch = searchParams.get("plan");
  const paymentMethodSearch = searchParams.get("paymentMethod");
  useInstantPurchase(Products);

  const pathSegments = location.pathname
    .split('/')
    .filter(segment => segment !== '' && segment !== 'comprar');
  const last_parameter = pathSegments[pathSegments.length - 1]

  const isInternalNavigation = location.state?.origin === 'internal_flow';
  useEffect(() => {
    // console.log("|||| payload", payload);
    if (payload.PostData?.product_id) {
      setPlanChosenId(payload.PostData.product_id[0]);
    }
  }, [payload]);

  useEffect(() => {
    dispatch({
      type: "RESET_PURCHASE",
    });
    return () => {
      if (["processed", "sessionUpdated"].includes(PurchaseInfo.SuccessState)) {
        global.updateSession(false);
      }
      dispatch({
        type: "RESET_PURCHASE",
      });
    }
  }, [])

  useEffect(() => {
    if (
      payload &&
      payload.purchase &&
      payload.purchase.errorList &&
      payload.purchase.step === "InvoiceData"
    ) {
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
          errorList: [],
        },
      });
    }
  }, []);

  useEffect(() => {
    if (Products && payload.PostData.product_id && !groupedData) {
      function groupByProductAndPeriodicity(data) {
        return data.reduce((result, item) => {
          const id = item.id_product;

          if (!result[id]) {
            result[id] = {
              id_currency: item.id_currency,
              prices: {},
            };
          }

          result[id].prices[item.periodicity] = item.price;

          return result;
        }, {});
      }

      setGroupedData(groupByProductAndPeriodicity(Products.periodicity));
    }
  }, [Products, payload]);

  useEffect(() => {
    fetchProducts({
      url: kApi.API_URL_PRODUCTS,
      method: "GET",
    });
  }, []);

  const PriceMonthly = (PlanId) => {
    return (
      groupedData &&
      groupedData[PlanId]?.prices?.monthly?.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      })
    );
  };

  const PriceAnnual = (PlanId) => {
    return (
      groupedData &&
      groupedData[PlanId]?.prices?.annual?.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      })
    );
  };

  const map_url_to_product_id = {
    "turbinar": {
      "usuarios": {
        "10": 6,
        "30": 5
      },
      "idiomas": {
        "pt-eu": 10,
        "en-us": 3,
        "es-es": 4,
      }
    },
    "plano": {
      "profissional/10": 13,
      "profissional/30": 16,
      "individual": 15,
      "familia": 14
    }
  }

  const get_product_id_by_url = (segments) => {
    if (segments.length === 0) return null;
    let currentLevel = map_url_to_product_id;
    for (const segment of segments) {
      if (currentLevel.hasOwnProperty(segment)) {
        currentLevel = currentLevel[segment];
      }else if (segment=="renovar"){
          currentLevel = map_url_to_product_id["plano"];
      } else if (["plano", "renovar"].indexOf(segments[0]) !== -1) {
        for (const key in currentLevel) {
          if (location.pathname.includes(key)) {
            currentLevel = currentLevel[key];
            break;
          }
        }
      }
    }
    if (typeof currentLevel === "number") 
      return currentLevel;
    else
      return null;
  }

  const map_urls_to_steps = useMemo(() => {
    const PriceMonthlyUsers = (id) => {
      const PlanValue = Products?.periodicity.filter(
        (item) => item.id === id && item.periodicity === "monthly"
      );
      if (!PlanValue || PlanValue.length === 0) return null
      return PlanValue[0]?.price?.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    };
    const getNameById = (id_product) => {
      const foundItem = Products?.periodicity?.find(
        (item) => item.id_product === id_product
      );
      return foundItem ? foundItem.name : null;
    };
    const product_id = get_product_id_by_url(pathSegments);
    return {
      "^\/(plano|renovar)\/([^/]+)(?:\/([^/]+))?\/(anual|mensal)$": {
        required: {
          isFree: true,
          isTrial: true,
        },
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
        },
        PostData: {
          periodicity: last_parameter === "mensal" ? "monthly" : "annual",
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          value: last_parameter === "mensal" ? PriceMonthly(product_id) : PriceAnnual(product_id),
          planName: getNameById(product_id),
          periodicity: last_parameter === "mensal" ? "monthly" : "annual",
        },
      },
      "^\/(turbinar)\/([^/]+)(?:\/([^/]+))?\/(anual|mensal)$": {
        required: {
          isFree: false
        },
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
        },
        PostData: {
          periodicity: last_parameter === "mensal" ? "monthly" : "annual",
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          value: last_parameter === "mensal" ? PriceMonthly(product_id) : PriceAnnual(product_id),
          planName: getNameById(product_id),
          periodicity: last_parameter === "mensal" ? "monthly" : "annual",
        },
      },
      "^\/turbinar\/usuarios\/(10|30)$": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "MyAddPurchase",
        },
        PostData: {
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email,
        },
        planInfo: {
          value: PriceMonthlyUsers(product_id)
        }
      },
      "^\/turbinar\/idiomas\/(es-es|en-us|pt-eu)(\/.*)?$": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "MyAddPurchase",
        },
        PostData: {
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email,
        },
        planInfo: {
          value: PriceMonthlyUsers(product_id)
        }
      },
      "/plano/profissional/30": {
        required: {
          isFree: true,
          isTrial: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "ProfPlanThirty",
        },
        PostData:{
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          planName: getNameById(product_id),
        }
      },
      "/plano/profissional/10": {
        required: {
          isFree: true,
          isTrial: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "ProfPlanTen",
        },
        PostData:{
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          planName: getNameById(product_id),
        }
      },
      "/plano/familia": {
        required: {
          isFree: true,
          isTrial: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "FamilyPlan",
        },
        PostData:{
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          planName: getNameById(product_id),
        }
      },
      "/plano/individual": {
        required: {
          isFree: true,
          isTrial: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "IndividualPlan",
        },
        PostData:{
          sub: session?.sub,
          product_id: [product_id],
          email: session?.email
        },
        planInfo: {
          planName: getNameById(product_id),
        }
      },
      "/plano/profissional": {
        required: {
          isFree: true,
          isTrial: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "ProfPlanUsers",
        }
      },
      "/turbinar/idiomas": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "SelectAddLang",
        }
      },
      "/turbinar/usuarios": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "SelectAddUsers",
        }
      },
      "/turbinar/languages": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "SelectAddLang",
        }
      },
      "/turbinar": {
        required: {
          isFree: false
        },
        purchase: {
          content: "ChooseAdd",
          step: "SelectRenewOrAdd",
        }
      },
      "/plano": {
        required: {
          isFree: true
        },
        purchase: {
          content: "ChoosePlan",
          step: "SelectPlan",
        }
      },
      "/renovar": {
        required: {
          isFree: true
        },
        purchase: {
          content: "RenewPlan",
          step: "RenewPlan",
        }
      }
    }
  }, [last_parameter, Products, groupedData, session]);

  const testRequirments = (requirements, infoUsers) => {
    let meetsRequirements = false;
    for (const key in requirements) {
      meetsRequirements = meetsRequirements || ((infoUsers[key]) == (requirements[key]))
    }
    return meetsRequirements
  }

  const checkPathMap = (pathSegments, map) => {
    const path = "/" + pathSegments.join('/');
    if (map.hasOwnProperty(path)) {
      return (testRequirments(map[path].required, infoUsers)) ? map[path] : null;
    }
    let wildcardMatch = false;
    for (const key in map) {
      const regex = new RegExp(key);
      if (regex.test(path)) {
        wildcardMatch = map[key];
        break;
      }

    }
    return (wildcardMatch && testRequirments(wildcardMatch.required, infoUsers)) ? wildcardMatch : null;
  }

  useEffect(() => {
    if (infoUsers && Products && session && infoUsers.sub) {
      initialRedirect()
    }
  }, [infoUsers, Products, groupedData, session,infoUsers]);


  const initialRedirect = () => {
    const config = checkPathMap(pathSegments, map_urls_to_steps)
    if(instantPay && instantPay ==1){
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "PaymentArea",
          step: "InvoiceData",
        },
        PostData: {
          sub: session?.sub,
          email: session?.email
        }
      })
    }
    else if (infoUsers && pathSegments.length > 0 && config) {
      dispatch({
        ...payload, ...config, ...{
          type: "PURCHASE"
        }
      })
    } else if (infoUsers.isFree === false && infoUsers.isTrial === false) {
      //if (!location.pathname.includes("/comprar/turbinar")) navigate('/comprar/turbinar', { state: { origin: 'internal_flow' } })
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "ChooseAdd",
          step: "SelectRenewOrAdd",
        },
        planInfo: {
          content: "ChooseAdd",
          step: "MyAddPurchase",
          pixPayment: false,
          pixIsPaid: false,
        },
      });
    } else if (infoUsers.hasLastPayment && infoUsers.isFree === true) {
      updateTagUser(["COMPRAR"])

      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "RenewPlan",
          step: "RenewPlan",
        },
        planInfo: {
          content: "RenewPlan",
          step: "RenewPlan",
          pixPayment: false,
          pixIsPaid: false,
        },
      });
    } else if (
      !infoUsers.hasLastPayment &&
      (infoUsers.isFree === true || infoUsers.isTrial === true)
    ) {
      updateTagUser(["COMPRAR"])

      dispatch({
        type: "PURCHASE",
        purchase: {
          content: "ChoosePlan",
          step: "SelectPlan",
        },
        planInfo: {
          content: "ChoosePlan",
          step: "SelectPlan",
          pixPayment: false,
          pixIsPaid: false,
        },
      });
    }
  }

  function pixel() {
    const dataobj = JSON.stringify({
      data: [
        {
          event_name: "ViewContent",
          event_time: Math.floor(+new Date() / 1000),
          action_source: "website",
          event_source_url: window.location.href,
          user_data: {
            em: [
              "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068",
            ],
            ph: [null],
            client_user_agent: null,
            client_ip_address: null,
          },
          custom_data: {
            currency: "USD",
            value: 39.9,
          },
        },
      ],
    });
    if (isProd) {
      fetch(kApi.API_PIXEL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: dataobj,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          console.log(JSON.stringify(data));
        });
    }
  }
  
  useEffect(() => {
    pixel();
  }, []);

  const MapRenderContent = {
    ChooseAdd: () => <ChooseAdd changePropertyUrl={changePropertyUrl} Products={Products} PriceMonthly={PriceMonthly} PriceAnnual={PriceAnnual} PlanChosenId={PlanChosenId} updateTagUser={updateTagUser} />,
    ChoosePlan: () => <ChoosePlan Products={Products} groupedData={groupedData} PlanChosenId={PlanChosenId} updateTagUser={updateTagUser} />,
    RenewPlan: () => <RenewPlan Products={Products} />,
    PaymentArea: () => <PaymentArea Products={Products} />,
    PaymentProcessing: () => <PaymentProcessing />,
    PurchaseSuccess: () => <PurchaseSuccess />,
  }
  const [content, setContent] = useState(null)
  const [purchaseState, setPurchaseState] = useState(0)

  useEffect(() => {
    if (Products && session && payload && infoUsers.sub && purchaseState === 0) {
      setPurchaseState(1)
    }
  }, [Products, session, payload,infoUsers])

  useEffect(() => {
    if (purchaseState == 1) {
      setPurchaseState(0)
      
      // console.log("payload.purchase", payload.purchase)
      if (MapRenderContent.hasOwnProperty(payload.purchase.content)) {
        const content = MapRenderContent[payload.purchase.content]()

        setContent(content)
      }
    }
  }, [purchaseState])


  return (
    <>
      <div className={`${classes.PurchaseMain} ${payload.purchase.content === 'PaymentArea' ? classes.PurchaseMainPaymentArea : ''}`}>
        {content}
      </div>
    </>
  );
};
export default Purchase;
